(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  // Apply Shopify's availability filter before pagination.
    // Products below the shared stock threshold have zero sellable inventory.
      if (url.searchParams.get('filter.v.availability') !== '1') {
          url.searchParams.set('filter.v.availability', '1');
              url.searchParams.delete('page');
                  window.location.replace(url.toString());
                    }

                      
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
